import { IGetAllContasPagarUseCase } from "../../../presentation/useCases/read/get_all_contas_pagar_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ContasPagarLista } from "../../models/contas_pagar_lista";
import { ContasPagarListaFilter } from "../../models/contas_pagar_lista_filter";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { ValoresContasMes } from "../../../../comercial/domain/models/valores_contas_mes";

/**
 * GetAllContasPagarUseCase
 */

export class GetAllContasPagarUseCase extends BasePaginatedUseCase<ContasPagarLista> implements IGetAllContasPagarUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllContasPagarLista(
    filter: ContasPagarListaFilter,
    currentPage: number,
    rowsPerPage: number
  ): Promise<ValoresContasMes> {
    const response = await this.repository.getAllContasPagarLista(filter, currentPage, rowsPerPage);

    this._items = response.lista.items;
    this._currentPage = response.lista.currentPage;
    this._pageSize = response.lista.pageSize;
    this._totalItems = response.lista.totalItems;
    this._totalPages = response.lista.totalPages;

    return response.indicadores;
  }
}
